import { useQuery } from '@tanstack/react-query';
import { queryFn, QUERY_KEY } from './queryFn';
import type { QueryKey } from './types';
import { ArticleTheme } from './enum';

export const useRecommendedArticles = (
  queryKey: QueryKey,
  currentArticleId
) => {
  const { data, status, isFetched, isFetching } = useQuery({
    queryKey,
    queryFn,
    staleTime: Infinity,
  });

  return {
    data:
      data?.articles
        .filter((article) => article.id !== currentArticleId)
        .slice(0, 3) || [],
    status,
    isFetched,
    isFetching,
  };
};

export const getRecommendedArticlesQueryKey = (): QueryKey => {
  return [...QUERY_KEY, 0, 4, ArticleTheme.MARKET_WRAP_UP];
};

export const getMarketInsightsQueryKey = (): QueryKey => {
  return [...QUERY_KEY, 0, 2, ArticleTheme.MARKET_WRAP_UP];
};
